import { CalendarEvent } from '../types/CalendarEvent';
import { Appointment } from '../types/Appointment';
import { ToastType } from '../pages/toast/ToastProvider';
import AppointmentService from '../services/appointmentService';
import { AppointmentType } from '../types/AppointmentType';
import { UtilsService } from '../services/utilsService';

const AppointmentHelpers = {
  
  convertCalendarEventToAppointment: (event: CalendarEvent): Appointment => {
    return {
      date: event.date ?? "",
      time: event.time ?? "",
      durationMinutes: event.durationMinutes ?? null,
      name: event.name ?? '',
      email: event.email ?? null,
      phone: event.phone ?? '',
      comments: event.comments ?? null,
      clinicId: event.clinicId ?? null,
      _id: event.appointmentId,
      appointmentType: event.appointmentType ?? null
    };
  },

  isEventUnchanged: (a: CalendarEvent | null , b: CalendarEvent | null) => {
    return (
      a?.appointmentId === b?.appointmentId &&
      a?.clinicId === b?.clinicId &&
      a?.title === b?.title &&
      a?.start === b?.start &&
      a?.end === b?.end &&
      a?.comments === b?.comments &&
      a?.date === b?.date &&
      a?.durationMinutes === b?.durationMinutes &&
      a?.email === b?.email &&
      a?.name === b?.name &&
      a?.phone === b?.phone &&
      a?.time === b?.time
    );
  },

  submitAppointment: async (appointment: Appointment, showToast: (msg: string, type: ToastType) => void, t: (key: string) => string, language: string, isTypesMode: boolean): Promise<Appointment | null> => {
    try {
      if (!appointment.date || !appointment.time) {
        showToast(t(`toastMessages.SELECT_DATE_TIME_FOR_APPOINTMENT`), ToastType.Warning);
        return null;
      }

      if (!UtilsService.validatePhoneNumber(appointment.phone)) {
        showToast(t(`toastMessages.ENTER_NAME_AND_VALID_PHONE`), ToastType.Warning);
        return null;
      }

      if (isTypesMode && !AppointmentHelpers.validateAppointmentType(appointment.appointmentType)) {
        showToast(t(`toastMessages.SELECT_APPOINTMENT_TYPE`), ToastType.Warning);
        return null;
      }

      const controller = new AbortController();
      const newAppointment = await AppointmentService.createAppointment(appointment, language, controller.signal);

      if (newAppointment?.error) {
        showToast(newAppointment.message, ToastType.Warning);
        return null;
      }

      showToast(t(`toastMessages.APPOINTMENT_BOOKED_SUCCESS`), ToastType.Success);
      return newAppointment;

    } catch (error: any) {
      showToast(error?.response?.data?.message || 'Failed to save appointment', ToastType.Error);
      return null;
    }
  },

  validateAppointmentType: (appointmentType: AppointmentType | null): boolean => {

    if (!appointmentType || appointmentType.name.trim() === '') {
      return false;
    }

     return true;
  }
}

export default AppointmentHelpers;
